<template>
  <span :class="{'highlighted': isHighlighted}">
    {{ stringToShow }}
  </span>
</template>

<script>
import DataTypeProsMixin from 'CORE/mixins/dataType'
import { get, startsWith } from 'lodash'

export default {
    name: 'StaticStringDetail',
    mixins: [
        DataTypeProsMixin,
    ],
    computed: {
        isDefaultValue() {
            return get(this.propertyType, 'settings.default_value.enabled', false)
        },
        isHighlighted() {
            return startsWith(this.id, 'system-')
        },
        stringToShow() {
            return get(this.value, 'value.value', '')
        },
    },
}
</script>

<style>
    .highlighted {
        font-weight: bold;
    }
</style>
